import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import type { Opportunity } from '@/core/opportunity/opportunity.model';
import { CREATE_OPPORTUNITY_URL } from '@/core/opportunity/opportunity.config';

@Injectable({ providedIn: 'root' })
export class OpportunityApi {
  private http = inject(HttpClient);

  async createOpportunity(): Promise<Opportunity> {
    return await firstValueFrom(this.http.post<Opportunity>(CREATE_OPPORTUNITY_URL, {}));
  }
}
